module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/bg_nagaitop03-93633acd0bec70183b48c826bc50653e.jpg";